import Boat from 'classes/Boat';
import Car from 'classes/Car';

import House from 'classes/House';
import Land from 'classes/Land';
import Plane from 'classes/Plane';
import propertyObjectTypes from './propertyObjectTypes';

export default Object.freeze({
  [propertyObjectTypes.house]: House,
  [propertyObjectTypes.land]: Land,
  [propertyObjectTypes.car]: Car,
  [propertyObjectTypes.boat]: Boat,
  [propertyObjectTypes.plane]: Plane,
});
